// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function debounce<T extends any[]>(
  func: (...args: T) => void,
  wait: number,
  immediate = false,
): (...args: T) => void {
  let timeout: number | undefined;
  return (...args: T) => {
    const later = () => {
      timeout = undefined;
      if (!immediate) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
        func(...args);
      }
    };

    const callNow = immediate && !timeout;
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(later, wait);
    if (callNow) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      func(...args);
    }
  };
}

import { useEffect, useState } from 'react';

export function useDebounceValue<T>(value: T, delay: number): T {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return debouncedValue;
}
